module.exports = "/static/assets/04a34cafd4ce4a8db665d21fcba81eb5.png";